import React, { ChangeEvent, useEffect, useState } from 'react';

import aguid from 'lib/aguid';
import RemindersGadgetForm from './RemindersGadgetForm';
import useEventTypes from './useEventTypes';
import withDateFilter from '../../hocs/withDateFIlter';

const RemindersGadgetFormContainer = ({
  gadget,
  onChange,
}: {
  gadget?: VisualisationDefinitions.Reminders;
  onChange?: React.Dispatch<
    React.SetStateAction<undefined | VisualisationDefinition>
  >;
}) => {
  const availableEventTypes = useEventTypes();

  // Base
  const [id] = useState(gadget ? gadget.id : aguid());
  const [name, setName] = useState<string>(gadget ? gadget.name : '');
  const [description, setDescription] = useState<string>(
    gadget ? gadget.description : '',
  );

  // Reminders Specific
  const [events, setEvents] = useState<string[]>(gadget ? gadget.events : []);
  // Misc
  const [draftGadget, setDraftGadget] = useState<
    VisualisationDefinitions.Reminders | undefined
  >(gadget ? { ...gadget } : undefined);

  const onNameChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const onDescriptionChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setDescription(event.target.value);
  };

  const isValid = name !== '' && events.length > 0;

  // Set the draft gadget
  useEffect(() => {
    setDraftGadget({
      type: 'Reminders',
      id,
      name,
      description,
      events,
    });
  }, [description, events, id, name]);

  useEffect(() => {
    if (draftGadget && onChange) {
      onChange(draftGadget);
    }
  }, [draftGadget, onChange]);

  const eventOptions = availableEventTypes.map((e) => ({
    label: e,
    onSelected: () => {
      setEvents((currentEvents) => {
        if (currentEvents.includes(e)) {
          return currentEvents.filter((ce) => ce !== e);
        } else {
          return [...currentEvents, e];
        }
      });
    },
    isSelected: events.includes(e),
  }));

  const selectedEventLabels = (() => {
    if (events.length === 0) {
      return 'None';
    } else if (events.length < 3) {
      return events.length === 0 ? 'None' : events.join(', ');
    } else {
      const additional = events.length - 2;
      if (additional === 1) {
        return `${events[0]}, ${events[1]} and ${events.length - 2} other`;
      } else {
        return `${events[0]}, ${events[1]} and ${events.length - 2} others`;
      }
    }
  })();

  return (
    <RemindersGadgetForm
      isLoading={false}
      name={name}
      onNameChanged={onNameChanged}
      description={description}
      onDescriptionChanged={onDescriptionChanged}
      eventOptions={eventOptions}
      isValid={isValid}
      draftGadget={draftGadget}
      selectedEventLabels={selectedEventLabels}
    />
  );
};

export default withDateFilter(RemindersGadgetFormContainer, {});
